import { Component } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { ReusableStreamProperty } from '@ipreo/muni-shared';
import { ViewOrderSummary, OrderSummaryData } from '../../models/summary';
import {
  orderSummaryMapper,
  viewOrderSummaryMapper
} from './order-summary-card.calculations';
import { GameDayRootReducerState } from '../../../state/root.state';
import { GameDayModel } from '../../../models/gameday-model';

@Component({
  selector: 'muni-gameday-order-summary-card',
  templateUrl: './order-summary-card.template.html',
  styleUrls: ['./order-summary-card.styles.scss'],
  standalone: false,
})
export class OrderSummaryCardComponent {
  public readonly highlightMaturityIdSink = new Subject<number>();

  @ReusableStreamProperty
  public readonly ordersSummary: Observable<
    ViewOrderSummary[]
  > = this.store.pipe(
    select(
      ({
        gameDay: {
          data: { orders },
          profile: { activeAccount }
        }
      }: GameDayRootReducerState) => ({ orders, activeAccount })
    ),
    filter(({ orders }: { orders: GameDayModel.Order[] }) => !!orders),
    map(orderSummaryMapper),
    filter(
      ({
        data,
        activeAccount
      }: {
        data: OrderSummaryData;
        activeAccount: string;
      }) => !!(data && activeAccount)
    ),
    map(viewOrderSummaryMapper)
  );

  @ReusableStreamProperty
  public readonly highlightMaturityId: Observable<
    number
  > = this.highlightMaturityIdSink.asObservable();

  constructor(private store: Store<GameDayRootReducerState>) {}

  public trackBy(index: number, order: ViewOrderSummary): number {
    return order.id;
  }

  public highlightOrder(orderId: number): void {
    this.highlightMaturityIdSink.next(orderId);
  }
}
